define('frontend-common-components/objectStorageConfig/js/helpers/azureHelper',[
	'./storageHelper'
], function (
	storageHelper
    ) {
    'use strict';

    //might need to update this variable if the length changes from default 100 to something else
    var AZURE_ACCEPTABLE_PREFIX_LENGTH;

    return {
        isValidBlobPrefix: function (directoryPrefix) {
            return storageHelper.isValidFilePrefix(directoryPrefix);
        },

        isAzureStoragePrefixLengthAcceptable: function (directoryPrefix) {
            return storageHelper.isStoragePrefixLengthAcceptable(directoryPrefix, AZURE_ACCEPTABLE_PREFIX_LENGTH);
        }
    };

});

